import React, { useEffect, useState } from "react";
import { useLocation, useOutletContext, useParams } from "react-router-dom";
import Layout from "../../Layout";
import Img from "../../../components/Img";
import axios from "axios";
import classNames from "classnames";
import ProjectSlider from "../common/ProjectSlider";
import { BeforeAfter } from "../../../components/BeforeAfter";
import ProjectCard from "../ProjectCard";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Icon } from "@iconify/react";
import SafeIFrame from "./SafeIFrame";
import {
  getMinioSize,
  getUpdatedImageUrlWithSize,
} from "../../../utils/helpers";
import FullPageImageSlider from "../../../components/FullPageImageSlider";
import ImgOptimized from "../../../components/ImgOptimized";
import BackBtn from "../../../components/BackBtn";

const ProjectShowcaseView = () => {
  const [projectData, setProjectData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const { state } = useLocation();
  let allProjects = state?.allProjects || [];
  allProjects = allProjects.filter(
    (p) => !!(Array.isArray(p?.thumbNail) ? p.thumbNail?.[0] : p?.thumbNail),
  );
  // console.log({ allProjects });
  // const [projectData, setProjectData] = useOutletContext();

  const { id } = useParams();
  const [sliderRef, setSliderRef] = useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACK_URL}/api/project-showcases/${id}`,
        );
        setProjectData(response.data);
        window.scrollTo(0, 0); // Scroll to top on project load
      } catch (error) {
        console.error("Failed to fetch project data", error);
      }
    };

    fetchProject();
  }, [id]);

  if (!projectData) {
    return null;
  }

  const {
    title,
    subTitle,
    sliderImages,
    featuredImages,
    imageTags = [],
    spaceSize,
    industry,
    location,
    textSection,
    beforeAfterImages,
    virtualLink,
    youtubeLink,
    buildingName,
  } = projectData;

  // Custom arrow components for react-slick
  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        className="!flex !items-center !justify-center !bg-primary-500 !rounded-full !w-10 !h-10 !shadow-lg ml-2"
        onClick={onClick}
        aria-label="Next"
        type="button"
      >
        <Icon
          icon="mingcute:arrow-right-line"
          className="text-white text-2xl"
        />
      </button>
    );
  };
  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        className="!flex !items-center !justify-center !bg-primary-500 !rounded-full !w-10 !h-10 !shadow-lg mr-2"
        onClick={onClick}
        aria-label="Previous"
        type="button"
      >
        <Icon icon="mingcute:arrow-left-line" className="text-white text-2xl" />
      </button>
    );
  };
  // console.log("allProjects", allProjects);
  const moreProjects = allProjects.filter((v) => v._id != id);
  const sliderSettings = {
    dots: false,
    infinite: moreProjects.length > 3,
    speed: 500,
    slidesToShow: Math.min(3, moreProjects.length),
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false, // disables default arrows
    nextArrow: null,
    prevArrow: null,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(2, moreProjects.length),
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Layout
      ProjectShowcase={true}
      isShowProjectDropDown={true}
      OnChangeSearchInput={(val) => {
        setSearchQuery(val);
      }}
      allProjects={allProjects}
    >
      <div className="p-3 xl:max-w-screen-lg xl:px-0 2xl:max-w-screen-xl mx-auto bg-white">
        <div className="mb-4 flex  items-start gap-3">
          <BackBtn className="mt-1.5 flex-shrink-0 cursor-pointer text-primary-500 w-6 h-6 hover:text-primary-600 transition-colors" />
          <div>
            <h1 className="text-2xl font-bold text-primary-500">{title}</h1>
            <p className="text-sm w-full max-w-screen-lg">{subTitle}</p>
          </div>
        </div>

        <ProjectSlider
          sliderImages={sliderImages}
          featuredImages={featuredImages}
          imageTags={imageTags}
        />

        <div className="flex flex-wrap items-center justify-center gap-x-6 md:gap-x-8 gap-y-3 mb-12">
          <div className="flex items-center gap-2 whitespace-nowrap text-base md:text-lg">
            <span className="font-semibold text-gray-800">Space Size -</span>
            <span className="text-gray-600">
              {Number(spaceSize).toLocaleString()} sqft
            </span>
          </div>
          {industry && (
            <div className="flex items-center gap-2 whitespace-nowrap text-base md:text-lg">
              <span className="font-semibold text-gray-800">Industry -</span>
              <span className="text-gray-600">{industry}</span>
            </div>
          )}
          {buildingName && (
            <div className="flex items-center gap-2 whitespace-nowrap text-base md:text-lg">
              <span className="font-semibold text-gray-800">
                Building Name -
              </span>
              <span className="text-gray-600">{buildingName}</span>
            </div>
          )}

          {(location?.city || location?.state) && (
            <div className="flex items-center gap-2 whitespace-nowrap text-base md:text-lg">
              <span className="font-semibold text-gray-800">Location -</span>
              <span className="text-gray-600">
                {location.city} {location?.state ? `, ${location?.state}` : ""}
              </span>
            </div>
          )}
        </div>

        {textSection?.map((item, idx) => (
          <TextSection key={idx} idx={idx} item={item} />
        ))}

        {(() => {
          const virtualLinks = Array.isArray(virtualLink)
            ? virtualLink.filter(Boolean)
            : virtualLink
              ? [virtualLink]
              : [];
          if (virtualLinks.length === 0) return null;
          return (
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-primary-500 text-center mb-3">
                {virtualLinks.length > 1 ? "Walkthroughs" : "Walkthrough"}
              </h2>
              <div className="space-y-4">
                {virtualLinks.map((link, idx) => (
                  <SafeIFrame key={idx} url={link} />
                ))}
              </div>
            </div>
          );
        })()}

        {youtubeLink && (
          <div className="mb-8">
            <h2 className="text-3xl font-bold text-primary-500 text-center mb-3">
              Video Showcase
            </h2>
            <div className="mb-4 relative rounded-2xl overflow-hidden bg-[#141414]">
              <iframe
                width="100%"
                height={500}
                src={youtubeLink}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
          </div>
        )}

        {(() => {
          const validImgs = (beforeAfterImages || []).filter(Boolean);
          const pairs = [];
          for (let i = 0; i + 1 < validImgs.length; i += 2) {
            pairs.push([validImgs[i], validImgs[i + 1]]);
          }
          if (pairs.length === 0) return null;
          return (
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-primary-500 text-center mb-3">
                Render vs Actual
              </h2>
              {pairs.map((pair, idx) => (
                <div
                  key={idx}
                  className="mb-4 relative rounded-2xl overflow-hidden"
                >
                  <BeforeAfter data={pair} />
                </div>
              ))}
            </div>
          );
        })()}
      </div>
      {allProjects?.length > 0 && (
        <div className="bg-gray-100 py-8">
          <div className="xl:max-w-screen-lg xl:px-0 2xl:max-w-screen-xl mx-auto">
            <div className="flex items-center justify-between mb-2">
              <h2 className="text-3xl font-bold text-primary-500 text-left">
                Other Projects
              </h2>
              <div className="flex gap-2">
                <button
                  onClick={() => sliderRef && sliderRef.slickPrev()}
                  className="!flex !items-center !justify-center !bg-primary-500 !rounded-full !w-10 !h-10 !shadow-lg mr-2"
                  aria-label="Previous"
                  type="button"
                >
                  <Icon
                    icon="mingcute:arrow-left-line"
                    className="text-white text-2xl"
                  />
                </button>
                <button
                  onClick={() => sliderRef && sliderRef.slickNext()}
                  className="!flex !items-center !justify-center !bg-primary-500 !rounded-full !w-10 !h-10 !shadow-lg ml-2"
                  aria-label="Next"
                  type="button"
                >
                  <Icon
                    icon="mingcute:arrow-right-line"
                    className="text-white text-2xl"
                  />
                </button>
              </div>
            </div>
            <div>
              <Slider ref={setSliderRef} {...sliderSettings}>
                {moreProjects
                  .filter((p) => !!(p.thumbNail?.[0] || p?.thumbNail))
                  .map((item) => (
                    <div key={item.id || item._id} className="px-2">
                      <ProjectCard
                        item={item}
                        allProjects={allProjects}
                        isViewOnly={true}
                        isEqualHeight={true}
                      />
                    </div>
                  ))}
              </Slider>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default ProjectShowcaseView;

const TextSection = ({ item, idx }) => {
  const [selectedIdx, setSelectedIdx] = useState(null);
  const imagesArr = [
    `${process.env.REACT_APP_BACK_URL}/api/minio/${item.textSectionImgs[0]}${getMinioSize()}`,
    ...item.textSectionImgs
      .slice(1)
      .map(
        (img, index) =>
          `${process.env.REACT_APP_BACK_URL}/api/minio/${img}${getMinioSize()}`,
      ),
  ];

  return (
    <>
      <div className="relative">
        {!item.isActive && (
          <p className="absolute top-5 right-5 text-xs text-white bg-red-600 py-1 px-2 rounded-full">
            Section Not Live
          </p>
        )}
        <div key={idx} className="relative">
          <div
            className={classNames(
              "mb-4 flex flex-col sm:flex-row gap-3 py-10 px-5 items-center rounded-3xl",
              {
                " sm:flex-row-reverse bg-primary-500 text-white": idx % 2 === 0,
              },
            )}
          >
            <div className="p-4 w-full  sm:w-2/5">
              <h2 className="text-2xl mb-3 font-bold">{item.title}</h2>
              <h3 className="text-lg mb-3 font-semibold">{item.subTitle}</h3>
              <p>{item.description}</p>
            </div>
            <div className=" w-full sm:w-3/5 relative">
              <ImgOptimized
                onClick={() => setSelectedIdx(0)}
                className="rounded-xl w-[85%] sm:w-[80%] h-[400px] object-cover cursor-pointer"
                src={getUpdatedImageUrlWithSize(
                  `${process.env.REACT_APP_BACK_URL}/api/minio/${item.textSectionImgs[0]}`,
                  [2, 2, 3],
                )}
                alt="Section main"
              />
              <div className="w-52 absolute top-1/2 -translate-y-1/2 right-5 sm:right-10">
                {item.textSectionImgs.slice(1).map((img, index) => (
                  <Img
                    key={index}
                    onClick={() => setSelectedIdx(index + 1)}
                    className="rounded-2xl mb-3 h-32 object-cover w-52 cursor-pointer"
                    src={getUpdatedImageUrlWithSize(
                      `${process.env.REACT_APP_BACK_URL}/api/minio/${img}`,
                      [1, 1, 1],
                    )}
                    alt={`Section ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedIdx != null && (
        <FullPageImageSlider
          images={imagesArr}
          isOpen={selectedIdx !== null}
          onClose={() => setSelectedIdx(null)}
          initialIndex={selectedIdx}
        />
      )}
    </>
  );
};
